const CartActionTypes = {
  INIT_ACTION: 'INIT_ACTION',
  UPDATING_ACTION: 'UPDATING_ACTION',
  UPDATE_ACTION: 'UPDATE_ACTION',
  UPDATED_ACTION: 'UPDATED_ACTION'
};

export default CartActionTypes;
